import React from "react";
import {
  FormControl,
  InputLabel,
  FormHelperText,
  TextField,
  Autocomplete,
  MenuItem,
  Select as MuiSelect,
  Box,
  Avatar,
} from "@mui/material";

function SearchableSelect(props) {
  console.log(props.options);
  const {
    name,
    label,
    value,
    style = { width: "100%", margin: "10px 0" },
    onChange,
    options,
    error,
    colorText = "black",
    searchable = false,
    ...other
  } = props;

  const styleDefault = { width: "100%", margin: "10px 0" };

  // Find the selected option object
  const selectedOption = options.find((option) => option.id === value) || null;

  const handleChange = (event, newValue) => {
    onChange({
      target: {
        name: name,
        value: newValue ? newValue.id : "",
      },
    });
  };

  // Common Avatar configuration
  const avatarProps = {
    imgProps: {
      style: {
        objectFit: "cover",
        width: "100%",
        height: "100%",
      },
    },
    variant: "rounded", // You can use "circular" for round images
  };

  if (searchable) {
    return (
      <FormControl
        variant="outlined"
        sx={{ ...styleDefault, ...style }}
        error={error ? true : false}
      >
        <Autocomplete
          options={options}
          getOptionLabel={(option) => option.name}
          value={selectedOption}
          onChange={handleChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              error={error}
              style={{ color: colorText }}
            />
          )}
          renderOption={(props, option) => (
            <Box
              key={option.id}
              component="li"
              sx={{
                "& > img": { mr: 2, flexShrink: 0 },
                display: "flex",
                alignItems: "center",
                gap: 1,
                padding: "8px",
              }}
              {...props}
            >
              {option.imageUrl && (
                <Avatar
                  src={option.imageUrl}
                  alt={option.name}
                  sx={{
                    width: 32,
                    height: 32,
                    // backgroundColor: "grey.200", // Fallback color while loading
                  }}
                  {...avatarProps}
                />
              )}
              <span>{option.name}</span>
            </Box>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Box
                key={option.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {option.imageUrl && (
                  <Avatar
                    src={option.imageUrl}
                    alt={option.name}
                    sx={{
                      width: 24,
                      height: 24,
                      // backgroundColor: "grey.200",
                    }}
                    {...avatarProps}
                  />
                )}
                <span>{option.name}</span>
              </Box>
            ))
          }
          {...other}
        />
        {error && <FormHelperText>This is required!</FormHelperText>}
      </FormControl>
    );
  } else {
    return (
      <FormControl
        variant="outlined"
        sx={{ ...styleDefault, ...style }}
        error={error ? true : false}
      >
        <InputLabel>{label}</InputLabel>

        <MuiSelect
          {...other}
          label={label}
          name={name}
          value={value}
          style={{ color: colorText, width: "100%" }}
          onChange={onChange}
          renderValue={(selected) => {
            const option = options.find((opt) => opt.id === selected);
            if (!option) return "";
            return (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  overflow: "hidden", // Prevent content from overflowing
                  textOverflow: "ellipsis", // Add ellipsis for long text
                  whiteSpace: "nowrap", // Keep text in single line
                }}
              >
                {option.imageUrl && (
                  <Avatar
                    src={option.imageUrl}
                    alt={option.name}
                    sx={{
                      width: 24,
                      height: 24,
                      // backgroundColor: "grey.200",
                      flexShrink: 0, // Prevent avatar from shrinking
                    }}
                    {...avatarProps}
                  />
                )}
                <span>{option.name}</span>
              </Box>
            );
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.id}
              value={option.id}
              sx={{
                padding: "8px", // Add consistent padding
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: "100%", // Ensure box takes full width
                }}
              >
                {option.imageUrl && (
                  <Avatar
                    src={option.imageUrl}
                    alt={option.name}
                    sx={{
                      width: 32,
                      height: 32,
                      // backgroundColor: "grey.200",
                      flexShrink: 0,
                    }}
                    {...avatarProps}
                  />
                )}
                <span>{option.name}</span>
              </Box>
            </MenuItem>
          ))}
        </MuiSelect>
        {error && <FormHelperText>This is required!</FormHelperText>}
      </FormControl>
    );
  }
}

export default SearchableSelect;
